// @flow
import moment from 'moment'
import type { Flight } from 'mz-sdk/services/flights/getFlights'

/**
 * Produce a string from the flight object. Show only flight code when
 * not both origin and destination airports defined
 * @param  {Flight} flight
 * @return {string}
 */
function flightToString(flight: Flight, options?: { compact?: boolean }) {
  const parts = []

  if (flight.flightCode || flight.flightNumber) {
    if (flight.flightNumber && flight.airlineCode && flight.airlineName) {
      const flightPrefix = options?.compact
        ? flight.airlineCode || flight.airlineName
        : flight.airlineName === flight.airlineCode
        ? flight.airlineName
        : `${flight.airlineName}(${flight.airlineCode})`
      parts.push(`${flightPrefix} ${flight.flightNumber}`)
    } else {
      parts.push(`${flight.flightCode}`)
    }
  }

  if (flight.origin && flight.destination && !options?.compact) {
    parts.push(`${flight.origin || ''} → ${flight.destination || ''}`)
    if (flight.time) {
      const parsedDatetime = moment.parseZone(flight.flightDatetime)
      const date = parsedDatetime.format('DD MMM')
      parts.push(date)
      parts.push(flight.time)
    }
  }

  return parts.join(' / ')
}

export default flightToString
